/**
 * Whether the first-visit SectionNudge toast is on screen (D10-UI-001, #3604).
 *
 * The nudge and the help bubble both live in the bottom-right corner; the
 * bubble reads this to step aside while a nudge is showing so the two never
 * overlap. A tiny external store rather than a context because SectionNudge is
 * mounted once at the app root, outside the layouts that render the bubble.
 */
import { useSyncExternalStore } from "react";

let visible = false;
const listeners = new Set<() => void>();

export function setSectionNudgeVisible(next: boolean): void {
  if (visible === next) return;
  visible = next;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSectionNudgeVisible(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => visible,
    () => false,
  );
}
